import { InvoiceQuery } from '../../models/invoice-query';
import { Invoice } from '../../models/invoice';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';

export interface InvoiceTableState {
    query: InvoiceQuery;
    page: Invoice[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    selection: string[];
}

export const selectInvoiceTableState = (state: AppState) => state.invoiceTable;

export const selectInvoiceTableQuery = createSelector(selectInvoiceTableState,
    (state: InvoiceTableState) => state.query);

export const selectInvoiceTablePage = createSelector(selectInvoiceTableState,
    (state: InvoiceTableState) => state.page);

export const selectInvoiceTableBusy = createSelector(selectInvoiceTableState,
    (state: InvoiceTableState) => state.busy);

export const selectInvoiceTableCount = createSelector(selectInvoiceTableState,
    (state: InvoiceTableState) => state.totalCount);

export const selectInvoiceTableSelection = createSelector(selectInvoiceTableState,
    (state: InvoiceTableState) => state.selection);
